import { Pagination } from '@mui/material';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import '../common-css/Table.css';
import { showTableResponse } from '../common-helpers/commonServices';
import NEET_CourseRecommendationModal from './NEET_CourseRecommendationModal';

const NEET_CourseRecommendations = () => {
    const childRef = useRef();
    const [records, setRecords] = useState([]);
    const [allRecords, setAllRecords] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loadData, setLoadData] = useState(false);

    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/neet/courseRecommendations').then((res) => {
            setRecords(res.data.data);
            setAllRecords(res.data.data);
        }).catch((error) => {
            console.log(error);
            toast.error(error?.response?.data?.message || "Error fetching data");
        });
    }, [loadData]);

    const handleDelete = async (Sn) => {
        if (!window.confirm('Are you sure you want to delete this recommendation?')) return;
        try {
            await axios.delete(BACKEND_SERVER_URL + `/neet/deleteCourseRecommendation/${Sn}`);
            toast.success('Deleted successfully');
            setLoadData(!loadData);
        } catch (error) {
            toast.error(error?.response?.data?.message || "Error deleting record");
        }
    };

    const pageSize = 50;
    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const paginatedRecords = records?.slice(firstIndex, lastIndex);
    const npage = Math.ceil(records?.length / pageSize);
    const number = [...Array(npage + 1).keys()].slice(1);

    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="page-title p-2 mb-2">
                                <div className='col-8 d-flex justify-content-between'>
                                    <div className="col-sm-4">
                                        <button type="button" className="btn btn-dark btn-sm me-2"
                                            onClick={() => childRef.current.openModal()}
                                        >
                                            + Add NEET Recommendation
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                            <div className='dataTables_info text-dark'>
                                Records: {records.length}
                            </div>
                            {records.length > pageSize &&
                                <div className="dataTables_paginate paging_simple_numbers justify-content-center mb-0 pt-2">
                                    <Pagination count={number.length} variant="outlined" color='primary' size="small" page={currentPage} siblingCount={1} boundaryCount={2} onChange={(e, p) => setCurrentPage(parseInt(p))} />
                                </div>
                            }
                        </div>
                        <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                            <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                <table className="table-responsive-lg table display dataTablesCard student-tab dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student">
                                    <thead style={{ backgroundColor: "#cccccc" }}>
                                        <tr className='text-center text-dark border border-left'>
                                            <th className='custom-table-header p-2' style={{ width: "60px" }}>Sl.No.</th>
                                            <th className='p-2 custom-table-header text-start'>TITLE</th>
                                            <th className='p-2 custom-table-header text-start'>LINK</th>
                                            <th className='custom-table-header p-2' style={{ width: "80px" }}>MIN %</th>
                                            <th className='custom-table-header p-2' style={{ width: "80px" }}>MAX %</th>
                                            <th className='custom-table-header p-2' style={{ width: "120px" }}>ACTION</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedRecords?.length > 0 ? paginatedRecords.map((item, ind) => (
                                            <tr key={ind} className={`${ind % 2 === 1 ? 'custom row-height' : 'row-height'}`}>
                                                <td className='text-center p-1' style={{ border: "1px solid #cccccc" }}>
                                                    <h6 className="text-primary mb-0">{item.Sn}</h6>
                                                </td>
                                                <td className='p-1 text-start' style={{ border: "1px solid #cccccc" }}>
                                                    <h6 className='mb-0' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.Title}</h6>
                                                </td>
                                                <td className='p-1 text-start' style={{ border: "1px solid #cccccc" }}>
                                                    <a href={item.Link} target="_blank" rel="noreferrer" style={{ fontSize: '12px' }}>{item.Link?.substring(0, 50)}{item.Link?.length > 50 ? '...' : ''}</a>
                                                </td>
                                                <td className='text-center p-1' style={{ border: "1px solid #cccccc" }}>
                                                    <span className="badge bg-warning">{item.MinPercentage}%</span>
                                                </td>
                                                <td className='text-center p-1' style={{ border: "1px solid #cccccc" }}>
                                                    <span className="badge bg-info">{item.MaxPercentage}%</span>
                                                </td>
                                                <td className="p-1 text-center" style={{ border: "1px solid #ccc" }}>
                                                    <CiEdit cursor='pointer' title='Edit' size={20} className='text-primary me-2' onClick={() => childRef.current.openModal(item)} />
                                                    <MdDeleteOutline color="red" title='Delete' cursor='pointer' size={20} onClick={() => handleDelete(item.Sn)} />
                                                </td>
                                            </tr>
                                        )) :
                                            <tr>
                                                <td colSpan="6" className="text-center">
                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                        {showTableResponse(allRecords, records)}
                                                    </div>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <NEET_CourseRecommendationModal ref={childRef} loadData={loadData} setLoadData={setLoadData} />
        </>
    )
}

export default NEET_CourseRecommendations;
